module.exports = __webpack_public_path__ + "static/media/camera-offline.50834f18.png";